var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mb-3" },
    [
      _vm.purchase.contract.supplementary_agreements &&
      ((_vm.purchase.contract.supplementary_agreements.length === 0 &&
        _vm.$store.getters.isLoggedIn &&
        _vm.purchase.flags.is_customer) ||
        _vm.purchase.contract.supplementary_agreements.length > 0)
        ? _c(
            "h3",
            {
              staticClass: "atmo-hash-jump-point",
              attrs: { id: "supplementary_agreements" },
            },
            [_vm._v(" Дополнительные соглашения ")]
          )
        : _vm._e(),
      _vm.purchase.contract.supplementary_agreements.length > 0
        ? _c(
            "div",
            { staticClass: "accordion", attrs: { role: "tablist" } },
            _vm._l(
              _vm.purchase.contract.supplementary_agreements,
              function (supplementaryAgreement, key) {
                return _c(
                  _vm.supplementaryAgreementComponent(supplementaryAgreement),
                  {
                    key: `supplementary-agreement-${key}`,
                    tag: "component",
                    attrs: {
                      pivc: _vm.pivc,
                      purchase: _vm.purchase,
                      "supplementary-agreement": supplementaryAgreement,
                      visible:
                        _vm.purchase.contract
                          .latest_supplementary_agreement_id ===
                        supplementaryAgreement.id,
                    },
                    on: {
                      refresh: function ($event) {
                        return _vm.refresh(null)
                      },
                    },
                  }
                )
              }
            ),
            1
          )
        : _vm._e(),
      _c("private-fl44-contract-send-supplementary-agreement-customer-block", {
        attrs: { pivc: _vm.pivc, purchase: _vm.purchase },
        on: {
          refresh: function ($event) {
            return _vm.refresh($event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }